
export const INIT_DATA_EXPIRED = 'INIT_DATA_EXPIRED';

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

function innerError(err: unknown): Record<string, unknown> | undefined {
  if (!isRecord(err)) return undefined;
  const candidate = isRecord(err.error) ? err.error : err;
  if (isRecord(candidate.error)) return candidate.error;
  if (typeof candidate.code === 'string' || typeof candidate.errorCode === 'string') return candidate;
  return undefined;
}

export function apiErrorCode(err: unknown): string | undefined {
  const inner = innerError(err);
  if (!inner) return undefined;
  if (typeof inner.errorCode === 'string') return inner.errorCode;
  if (typeof inner.code === 'string') return inner.code;
  return undefined;
}

export function apiErrorMessage(err: unknown): string | undefined {
  const inner = innerError(err);
  return inner && typeof inner.message === 'string' ? inner.message : undefined;
}

export function apiErrorDetails(err: unknown): Record<string, unknown> | undefined {
  const details = innerError(err)?.details;
  return isRecord(details) ? details : undefined;
}

export function formatApiError(err: unknown): string {
  const status = isRecord(err) && typeof err.status === 'number' ? err.status : undefined;
  const statusText = isRecord(err) && typeof err.statusText === 'string' ? err.statusText : undefined;
  const code = apiErrorCode(err);
  const message = apiErrorMessage(err);

  const parts: string[] = [];
  if (status !== undefined) parts.push(statusText && !message ? `HTTP ${status} ${statusText}` : `HTTP ${status}`);
  if (code) parts.push(code);
  if (message) parts.push(message);
  if (parts.length > 0) return parts.join(' — ');

  if (err instanceof Error) return `${err.name}: ${err.message}`;
  return String(err);
}
